var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onOpenInspectionList.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('inspection.inspection_history')))])
}
var staticRenderFns = []

export { render, staticRenderFns }